import React from 'react';
import { motion } from 'framer-motion';
import { FiGithub, FiExternalLink, FiStar } from 'react-icons/fi';
import { projects } from '../data/portfolioData';
import { trackEvent } from '../utils/analytics';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 },
  },
};

const toFilename = (title) =>
  title.toLowerCase().replace(/\s+/g, '-') + '.jsx';

const Projects = () => {
  return (
    <section id="projects" className="projects">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
      >
        <motion.h2 className="section-comment" variants={itemVariants}>
          {'// projects'}
        </motion.h2>
        <motion.p className="section-subtitle" variants={itemVariants}>
          Selected work and side projects
        </motion.p>

        <motion.div className="projects-grid" variants={containerVariants}>
          {projects.map((project, index) => (
            <motion.div
              className="project-card"
              key={index}
              variants={cardVariants}
              whileHover={{
                y: -6,
                borderColor: 'var(--accent, #61dafb)',
                transition: { duration: 0.2 },
              }}
            >
              <div className="project-tab">
                <div className="project-tab-info">
                  <span className="project-tab-dot" />
                  <span className="project-tab-name">{toFilename(project.title)}</span>
                </div>
                {project.featured && (
                  <span className="featured-badge">
                    <FiStar />
                  </span>
                )}
              </div>

              <div className="project-body">
                <p className="project-description">{project.description}</p>

                <div className="project-technologies">
                  {project.technologies.map((tech, i) => (
                    <span className="project-tech-tag" key={i}>
                      {tech}
                    </span>
                  ))}
                </div>

                <div className="project-links">
                  {project.github && (
                    <a
                      href={project.github}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-link"
                      onClick={() =>
                        trackEvent('project_link_click', {
                          project_name: project.title,
                          link_type: 'github',
                        })
                      }
                      aria-label="GitHub repository"
                    >
                      <FiGithub />
                    </a>
                  )}
                  {project.live && (
                    <a
                      href={project.live}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-link"
                      onClick={() =>
                        trackEvent('project_link_click', {
                          project_name: project.title,
                          link_type: 'live_demo',
                        })
                      }
                      aria-label="Live demo"
                    >
                      <FiExternalLink />
                    </a>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Projects;
